import { render, staticRenderFns } from "./ReleasedTable.vue?vue&type=template&id=a19db944&scoped=true"
import script from "./ReleasedTable.vue?vue&type=script&lang=js"
export * from "./ReleasedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19db944",
  null
  
)

export default component.exports